var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccesSendRequest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 100",
    style: {
      enableBackground: "new 0 0 114 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;}\n\t.st1{fill:#6A148E;}\n\t.st2{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#C198ED;enable-background:new    ;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#BCBCBC;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#6A148E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8348",
    transform: "translate(-17451.039 -5457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8346",
    transform: "translate(17479.447 5482.072)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.06,1.74c-0.28-1.04-0.94-1.9-1.87-2.44c-0.93-0.54-2.02-0.68-3.05-0.4L5.72,11.6 c-0.99,0.26-1.83,0.89-2.37,1.75c-0.57,0.91-0.75,1.99-0.51,3.04c0.24,1.05,0.88,1.94,1.79,2.51l20.28,12.67c0,0,0,0,0,0 c0.19,0.12,0.36,0.29,0.48,0.48l12.67,20.28c0.54,0.87,1.38,1.49,2.37,1.75c0.35,0.09,0.7,0.14,1.05,0.14c0.7,0,1.38-0.18,2-0.54 c0.93-0.54,1.6-1.41,1.87-2.44L58.06,3.82C58.24,3.14,58.24,2.42,58.06,1.74z M5.95,16.77c-0.35-0.22-0.59-0.55-0.68-0.95 c-0.09-0.4-0.02-0.8,0.19-1.15c0.2-0.33,0.52-0.56,0.9-0.66l47.42-12.7c0.04-0.01,0.08-0.01,0.11-0.02L25.93,29.25L5.95,16.77z  M42.94,50.59c-0.11,0.39-0.36,0.72-0.71,0.92s-0.76,0.26-1.16,0.15c-0.37-0.1-0.69-0.34-0.9-0.66L27.7,31.02L55.66,3.06 c-0.01,0.04,0,0.08-0.01,0.11L42.94,50.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.8,54.4c-0.32,0-0.64-0.12-0.88-0.37c-0.49-0.49-0.49-1.28,0-1.77l18.8-18.8c0.49-0.49,1.28-0.49,1.77,0 s0.49,1.28,0,1.77l-18.8,18.8C4.44,54.28,4.12,54.4,3.8,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.14,43.09c-0.32,0-0.64-0.12-0.88-0.37c-0.49-0.49-0.49-1.28,0-1.77L10.4,29.81c0.49-0.49,1.28-0.49,1.77,0 s0.49,1.28,0,1.77L1.02,42.72C0.78,42.97,0.46,43.09,0.14,43.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.11,58.07c-0.32,0-0.64-0.12-0.88-0.37c-0.49-0.49-0.49-1.28,0-1.77l11.15-11.15 c0.49-0.49,1.28-0.49,1.77,0s0.49,1.28,0,1.77L16,57.7C15.75,57.94,15.43,58.07,15.11,58.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8347",
    transform: "translate(17451.039 5457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8349",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3084",
    className: "st2",
    d: "M8.21,6.57c-1.92,9.53-0.5,7.77-7.52,10.45c6.94,2.59,5.6,0.75,7.52,10.36 c2.01-9.53,0.58-7.69,7.6-10.36C8.88,14.34,10.21,16.18,8.21,6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3085",
    className: "st3",
    d: "M28.68,0c-1,4.97-0.26,4.06-3.92,5.45c3.62,1.35,2.92,0.39,3.92,5.41 c1.05-4.97,0.3-4.01,3.97-5.41C29.03,4.06,29.73,5.01,28.68,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3087",
    className: "st4",
    d: "M2.25,34.1c-0.54,2.67-0.14,2.18-2.11,2.93c1.95,0.72,1.57,0.21,2.11,2.91 c0.56-2.67,0.16-2.16,2.13-2.91C2.44,36.29,2.81,36.8,2.25,34.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8116",
    transform: "translate(78.72 56.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3086",
    className: "st2",
    d: "M28.26,27.45c-1.3,6.42-0.34,5.24-5.07,7.04c4.67,1.75,3.77,0.51,5.07,6.98 c1.35-6.42,0.39-5.18,5.12-6.98C28.71,32.69,29.61,33.92,28.26,27.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3087-2",
    className: "st3",
    d: "M2.25,37.24c-0.54,2.67-0.14,2.18-2.11,2.93c1.95,0.72,1.57,0.21,2.11,2.91 c0.56-2.67,0.16-2.16,2.13-2.91C2.44,39.42,2.81,39.94,2.25,37.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3087-3",
    className: "st3",
    d: "M33.01,0c-0.54,2.67-0.14,2.18-2.11,2.93c1.95,0.72,1.57,0.21,2.11,2.91 c0.56-2.67,0.16-2.16,2.13-2.91C33.2,2.18,33.57,2.7,33.01,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3087-4",
    className: "st4",
    d: "M25.28,21.48c-0.54,2.67-0.14,2.18-2.11,2.93c1.95,0.72,1.57,0.21,2.11,2.91 c0.56-2.67,0.16-2.16,2.13-2.91C25.47,23.67,25.85,24.18,25.28,21.48z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesSendRequest);
export default __webpack_public_path__ + "static/media/succesSendRequest.c1bc8d0ada405d5e7b73dd137e951881.svg";
export { ForwardRef as ReactComponent };